// extracted by mini-css-extract-plugin
module.exports = {"container":"Processing_container__3g7La","title":"Processing_title__3f-ip","description":"Processing_description__3vTUt"};